import axios from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import AllDomainValue from '../../utils/mescs.json';
import MescModal from "../helper/MescModal";
import Keywords from '../../utils/keywords.json';
import { MyContext } from "../helper/MyContext";

const FormData = require('form-data');

export function StepThree(props) {
    const url = 'https://khpc.ir/sup-upload/';

    const [submit, setSubmit] = useState(false);
    const [firstData, setFirstData] = useState(true);
    const { user } = useContext(MyContext);
    const [activity, setActivity] = useState([
        {
            id: 1,
            checked: false,
            hasAttach: false,
            hasValue: false,
            value: '',
            attach: '',
            label: 'تولیدی'
        },
        {
            id: 2,
            checked: false,
            hasAttach: false,
            hasValue: false,
            value: '',
            attach: '',
            label: 'بازرگانی'
        },
        {
            id: 3,
            checked: false,
            hasAttach: false,
            hasValue: false,
            value: '',
            attach: '',
            label: 'فروشنده / واسطه'
        },
        {
            id: 4,
            checked: false,
            hasAttach: true,
            hasValue: true,
            value: '',
            attach: '',
            label: 'نمایندگی‌ تجاری'
        },
        {
            id: 5,
            checked: false,
            hasAttach: true,
            hasValue: true,
            value: '',
            attach: '',
            label: 'نمایندگی‌فروش‌وخدمات'
        },
        {
            id: 6,
            checked: false,
            hasAttach: true,
            hasValue: true,
            value: '',
            attach: '',
            label: 'نمایندگی‌انحصاری'
        },
        {
            id: 7,
            checked: false,
            hasAttach: false,
            hasValue: true,
            value: '',
            attach: '',
            label: 'سایر'
        },
        {
            id: 8,
            checked: false,
            hasAttach: false,
            hasValue: true,
            value: '',
            attach: '',
            label: 'سایر برندهای قابل تامین'
        }
    ]);


    const [scopeActivity, setScopeActivity] = useState([]);
    const [fieldActivity, setFieldActivity] = useState([]);
    const [descriptionActivity, setDescriptionActivity] = useState([]);

    const [errorActivity, setErrorActivity] = useState(false);
    const [errorScopeActivity, setErrorScopeActivity] = useState(false);
    const [errorFieldActivity, setErrorFieldActivity] = useState(false);

    useEffect(() => {
        let Mount = true;
        if (Mount) {
            let datao = new FormData();
            datao.append('userId', user);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/getRequestByUserId',
                data: datao
            };

            axios.request(config)
                .then((response) => {
                    var dataLoaded = JSON.parse(response.data.data.dataThree);
                    setActivity(dataLoaded.activity);
                    setScopeActivity(dataLoaded.scopeActivity);
                    setFieldActivity(dataLoaded.fieldActivity);
                    setDescriptionActivity(dataLoaded.descriptionActivity);
                    setCertificate(dataLoaded.certificate)
                    setFirstData(false)
                })
                .catch((error) => {
                    setFirstData(false)
                    // alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                });
        }
        return () => Mount = false;
    }, []);




    const handleActivity = (e) => {

        const newState = activity.map(obj => {
            if (obj.id == e.target.value) {
                return { ...obj, checked: e.target.checked };
            }
            return obj;
        });

        setActivity(newState);
    }

    const handleValue = (val, id) => {
        const newState = activity.map(obj => {
            if (obj.id == id) {
                return { ...obj, value: val, checked: true };
            }
            return obj;
        });

        setActivity(newState);
    }

    const uploadAttach = async (event, id) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                const newState = activity.map(obj => {
                    if (obj.id == id) {
                        return { ...obj, attach: res.data.name, checked: true };
                    }
                    return obj;
                });

                setActivity(newState);
            })
            .catch(err => {
                console.log(err)
            })
    }

    const handleFieldActivity = (id) => {
        if (fieldActivity.includes(id)) {
            var newValue = fieldActivity.filter(item => item !== id);
            setFieldActivity(newValue);
        } else {
            setFieldActivity(prevState => [...prevState, id])
        }
    }

    const [certificate, setCertificate] = useState('');
    const [startCertificate, setStartCertificate] = useState(false);

    const UploadCertificate = async (event) => {
        if (event.target.files[0]?.type !== 'application/x-zip-compressed' && event.target.files[0]?.type !== 'application/zip') {
            alert('پسوند فایل بایستی zip باشد');
            return;
        }
        setStartCertificate(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setCertificate(res.data.name)
                setStartCertificate(false)

            })
            .catch(err => {
                console.log(err)
                setStartCertificate(false)
            })
    }

    const changeStepBack = () => {

        window.scrollTo(0, 0);
        props.backStep("2");

    }

    const changeStep = () => {
        setSubmit(true);
        if (activity.filter(value => value.checked == false).length == 8 ||
            Object.keys(scopeActivity).length == 0 ||
            Object.keys(fieldActivity).length == 0 ||
            descriptionActivity == '') {
            alert('فیلدهای مشخص شده الزامی هستند');

            if (activity.filter(value => value.checked == false).length == 8) {
                setErrorActivity(true);
            } else {
                setErrorActivity(false);
            }
            if (Object.keys(scopeActivity).length == 0) {
                setErrorScopeActivity(true);
            } else {
                setErrorScopeActivity(false);
            }
            if (Object.keys(fieldActivity).length == 0) {
                setErrorFieldActivity(true);
            } else {
                setErrorFieldActivity(false);
            }


        } else {
            window.scrollTo(0, 0);
            var data = {
                activity: activity,
                scopeActivity: scopeActivity,
                fieldActivity: fieldActivity,
                descriptionActivity: descriptionActivity,
                certificate: certificate
            };

            let dataForm = new FormData();
            dataForm.append('userId', user);
            dataForm.append('json', JSON.stringify(data));

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/sendRequestStepThree',
                data: dataForm
            };

            axios.request(config)
                .then((response) => {
                    if (response.data.error) {
                        alert(response.data.message);
                    } else {
                        props.setData(data);
                        props.changeStep();
                    }
                    setSubmit(false);
                })
                .catch((error) => {
                    alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                    setSubmit(false);
                });

        }
    }

    if (firstData) {
        return (
            <>
                <Container className="mt-2" >
                    <Row>
                        <Col xs="12">
                            در حال بارگزاری
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }

    return (
        <>
            <Container className="mt-2" >
                <Row>
                    <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                        <label className="text-g fw-bold">نوع فعالیت (سایر برندهای قابل تامین با # جدا شود) <sup style={{ color: 'red', fontSize: 13 }}>*</sup></label>
                    </Col>
                    <Col xs={12} className="mt-4 py-2">

                        {
                            errorActivity && <div className="my-3 alert alert-danger">⚠️ انتخاب نوع فعالیت الزامی است</div>
                        }

                        {
                            activity.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Row className="my-3">
                                            <Col xs={12} md={3}>
                                                <Form.Check
                                                    type={'checkbox'}
                                                    id={`default-checkbox-${item.id}`}
                                                    value={item.id}
                                                    checked={item.checked}
                                                    onChange={(e) => handleActivity(e)}
                                                    label={item.label}
                                                />

                                            </Col>
                                            {
                                                item.hasValue &&
                                                <Col xs={12} md={4}>
                                                    <Form.Control isInvalid={submit && item.checked && item.hasValue && item.value == ''} value={item.value} onChange={(e) => handleValue(e.target.value, item.id)} type="text" />
                                                </Col>
                                            }
                                            {
                                                item.hasAttach &&
                                                <Col xs={12} md={3}>
                                                    <Form.Group>
                                                        <Form.Control isInvalid={submit && item.checked && item.hasAttach && item.attach == ''} onChange={(e) => uploadAttach(e, item.id)} type="file" size="sm" accept=".pdf" />
                                                    </Form.Group>
                                                </Col>
                                            }
                                            {
                                                item.attach !== '' &&
                                                <Col xs={12} md={2}>
                                                    <a target="_blank" rel="noreferrer" className="mb-2" href={url + item.attach} download>نمایش فایل</a>
                                                </Col>
                                            }
                                        </Row>
                                    </div>
                                )
                            })
                        }
                    </Col>
                    <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                        <label className="text-g fw-bold">دامنه فعالیت (براساس MESC نفت)<sup style={{ color: 'red', fontSize: 13 }}>*</sup></label>
                    </Col>
                    <Col xs={12} className="mt-4 py-2">
                        {
                            errorScopeActivity && <div className="my-3 alert alert-danger">⚠️ انتخاب دامنه فعالیت الزامی است</div>
                        }
                        <MescModal sendValues={(data) => setScopeActivity(data)} value={scopeActivity} />
                    </Col>
                    <Col xs={12} className="mt-4 py-2">
                        <label style={{ fontWeight: 'bold' }}>انتخاب شده ها </label>
                        {
                            scopeActivity.map((item, index) => {
                                return <div key={index}>{index + 1} - {AllDomainValue.find(ite => ite.id == item)?.PersianTitle} </div>
                            })
                        }
                    </Col>
                    <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                        <label className="text-g fw-bold">زمینه فعالیت<sup style={{ color: 'red', fontSize: 13 }}>*</sup></label>
                    </Col>
                    <Col xs={12} className="mt-4 py-2">
                        {
                            errorFieldActivity && <div className="my-3 alert alert-danger">⚠️ انتخاب زمینه فعالیت الزامی است</div>
                        }
                        <Row>
                            {
                                Keywords.map((item, index) => {
                                    return (
                                        <div key={index} style={{ marginBottom: 30 }}>
                                            <label style={{ fontWeight: 'bold', marginBottom: 5 }}>{item.title}</label>
                                            <Row>
                                                {
                                                    item.child.map((ite, ind) => {
                                                        return (
                                                            <Col xs={12} md={3} key={ind}>
                                                                <Form.Check
                                                                    type={'checkbox'}
                                                                    id={`default-checkbox-${ite.id}`}
                                                                    value={ite.id}
                                                                    checked={fieldActivity.includes(ite.id)}
                                                                    onChange={(e) => handleFieldActivity(ite.id)}
                                                                    label={ite.title}
                                                                />

                                                            </Col>
                                                        )
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    )
                                })

                            }
                        </Row>
                    </Col>
                    <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                        <label className="text-g fw-bold">*شرح فعالیت <sup style={{ color: 'red', fontSize: 13 }}>*</sup></label>
                        <p>
                            لطفا از وارد کردن متن طولانی و توضیحات اضافی خودداری نمایید.حداکثر طول قابل قبول 1000 کاراکتر می باشد. نمونه: تامین یا ساخت انواع ولو(چک ولو، بال ولو، گیت ولو، ...)
                        </p>
                    </Col>
                    <Col xs={12} className="mt-4 py-2">
                        <Form.Group>
                            <Form.Control isInvalid={submit && descriptionActivity == ''} value={descriptionActivity} onChange={(e) => setDescriptionActivity(e.target.value)} as="textarea" rows={3} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} className="mt-4">
                        <Form.Group controlId="formFile3" className="mb-4">
                            <Form.Label>مستندات سوابق کاری و گواهی حسن انجام کار :(فرمت zip)</Form.Label>
                            <Form.Control disabled={startCertificate} onChange={(e) => UploadCertificate(e)} type="file" size="sm" accept=".zip" />
                        </Form.Group>
                        {
                            certificate &&
                            <a target="_blank" rel="noreferrer" className="mb-2" href={url + certificate} download>نمایش فایل</a>
                        }
                        <hr />
                    </Col>
                    <Col xs={12} className="mt-4 text-center">
                        <div className="d-grid gap-2">
                            <Button variant="success" onClick={() => changeStep()}>
                                مرحله بعد
                            </Button>

                            <Button variant="muted" className="mt-2" onClick={() => changeStepBack()}>
                                مرحله قبل
                            </Button>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}